import React, { useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import useEditorStore from "@/store/useEditorStore";
import { FlowPort } from './FlowPort';
import { getLabelParts } from '@/utils/helper';

const node_width = 100;
const node_height = 30;


export const D3Node = ({ onDbClick, payload }) => {
    const SetMouseOnNode = useEditorStore.use.SetMouseOnNode();
    const selectedNode = useEditorStore.use.selectedNode();
    const setSelectedNode = useEditorStore.use.setSelectedNode();
    const setOpMode = useEditorStore.use.setOpMode();
    const movingSet = useEditorStore.use.movingSet();
    const {id, x, y, name,icon,color,inputs,outputs,align } = payload;
    const selected = movingSet.includes(payload.id);
    //const outputs = _outputs > payload.wires.length? _outputs : payload.wires.length;
    const groupRef = useRef(null);
    const nodeRef = useRef(null);
    const labelParts = getLabelParts(name,"red-ui-flow-node-label");
    const width = Math.max(node_width,20*(Math.ceil((labelParts.width+50+(inputs>0?7:0))/20)) );
    const height = Math.max(6+24*labelParts.lines.length,(outputs || 0) * 15, 30);


    return (<g onMouseDown={(e)=>{
        e.preventDefault();
        e.stopPropagation();
        setOpMode(2);
        // 获取 SVG 元素相对于视口的位置
        const rect = e.target.getBoundingClientRect();

        // 计算鼠标点击相对于 SVG 元素的坐标
        const offsetX = e.clientX - rect.left;
        const offsetY = e.clientY - rect.top;
        setSelectedNode(payload.id,offsetX,offsetY);
        console.log(e);
    }} onDoubleClick={()=>{
        onDbClick(payload);
    }} onMouseEnter={(e)=>{
        //console.log(e);
        SetMouseOnNode(payload.id);
    }} onMouseLeave={(e)=>{
        //console.log(e);
        SetMouseOnNode(null);
    }} ref={nodeRef} className={`red-ui-flow-node ${(payload.id == selectedNode?.id || selected)?"red-ui-flow-node-selected":""}`} transform={`translate(${x},${y})`}>
        <rect className="red-ui-flow-node " rx="5" ry="5" fill={color} width={width} height={height}></rect>
        <g ref={groupRef} className={`red-ui-flow-node-icon-group ${align == "right"? "red-ui-flow-node-icon-group-right":""}`} x="0" y="0" transform={`translate(${align == "right"?width-30:0},0)`}>
            <path x="0" y="0" className="red-ui-flow-node-icon-shade" d={`M5 0 h25 v${height} h-25 a 5 5 0 0 1 -5 -5  v-20 a 5 5 0 0 1 5 -5`}></path>
            <path d="M 29.5 0.5 l 0 29" className="red-ui-flow-node-icon-shade-border"></path>
            <image href={`/asset/images/${icon}`} x="0" y={height/2-15} width="30" height="30"></image>
        </g>
        <g className="red-ui-flow-node-label" transform={`translate(38,${height/2})`}>
            <text className="red-ui-flow-node-label-text" x="0" y="0">{name}</text>
        </g>
        {Array.from({ length: inputs }, (_, i) => (
            <FlowPort nodeId={id} key={i} x={- 5} index={i} y={height/2-5} dir={-1} />
        ))}

        {Array.from({ length: outputs }, (_, i) => (
            <FlowPort nodeId={id} key={i} index={i} x={width - 5} y={((height/2)-(outputs/2)*13)+13*i} dir={1} />
        ))}
    </g>);
}